import angular from 'angular';
import '../resources/metadata';

const module = angular.module('whyline.services.metadata', [
  'whyline.resources.metadata',
]);

let Metadata;

class MetadataService {
    static $inject = ['Metadata'];

    constructor (MetadataInjected) {
        Metadata = MetadataInjected;
    }

    getPlaceMetadata = (placeId, filterParam) => {
        return Metadata.getPlaceMetadata(placeId, filterParam);
    }

    getPlaceMetadataFields = (placeId) => {
        return Metadata.getPlaceMetadataFields(placeId);
    }

    getMetadataData = (filterParam) => {
        return Metadata.getMetadataData(filterParam);
    }

    getMetadataFields = () => {
        return Metadata.getMetadataFields();
    }
}

module.exports = module.service('MetadataService', MetadataService);

